import React from 'react';
import { ActivityIcon, GraduationCapIcon, PhoneIcon, RouteIcon, UsersRoundIcon } from 'lucide-react';
import { CONTACT } from '../../data/modalities';
const REVIEW_FACTORS = [{
  label: 'Patient Needs',
  icon: UsersRoundIcon
}, {
  label: 'Practice Workflow',
  icon: ActivityIcon
}, {
  label: 'Product Training',
  icon: GraduationCapIcon
}, {
  label: 'Implementation Plan',
  icon: RouteIcon
}];
export function WelcomeVideo() {
  return <section className="before-you-buy w-full overflow-hidden bg-white px-4 py-20 sm:px-0 sm:py-24" data-id="element-499" data-mp="37kgem765pd17">
      <div className="before-you-buy__inner mx-auto grid w-full max-w-[358px] items-center gap-10 sm:max-w-7xl sm:px-8 lg:grid-cols-[1.05fr_0.95fr]" data-id="element-500" data-mp="32ld96lm9l4sp">
        <div className="before-you-buy__copy w-full min-w-0" data-id="element-501" data-mp="3bnw7csf3ut8m">
          <h2 className="before-you-buy__heading w-full max-w-full whitespace-normal break-words font-display text-[30px] font-bold leading-[1.08] tracking-tight text-navy sm:max-w-xl sm:text-[2.4rem] sm:leading-tight" data-id="element-502" data-mp="3bmbh3eztpwgk">
            The Right Equipment = Better Outcomes
          </h2>
          <p className="before-you-buy__copy-text mt-5 w-full max-w-full text-[16px] leading-relaxed text-charcoal/75 sm:max-w-xl" data-id="element-503" data-mp="r3sbcw3sja3">
            A quick conversation can help a practice avoid investing in
            technology that does not match its patients, workflow, budget, or
            training capacity. JAG Medical Solutions helps doctors compare
            modalities, understand implementation needs, and choose equipment
            with a clear plan for adoption.
          </p>
          <a href={CONTACT.phoneHref} className="before-you-buy__cta mt-8 inline-flex max-w-full items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-504" data-mp="3iz1k6vsk2s73">
            <PhoneIcon className="h-[18px] w-[18px] shrink-0" data-id="element-505" data-mp="185yq77k6hxgf" />
            Book a Call
          </a>
        </div>

        <aside className="before-you-buy__card mx-auto w-full min-w-0 rounded-3xl border border-slate-200 bg-white shadow-[0_28px_65px_-30px_rgba(26,27,75,0.38)] sm:max-w-none" data-id="element-506" data-mp="348lct26k8r6x">
          <div className="before-you-buy__card-body p-5 sm:p-6" data-id="element-507" data-mp="3daupnypawwnh">
            <div className="h-1 w-10 rounded-full bg-teal" aria-hidden="true" data-id="element-508" data-mp="398zn6qvmwd84" />
            <h3 className="mt-5 font-display text-xl font-bold text-navy" data-id="element-509" data-mp="396v9jh7xnzun">
              The JAG Medical Solutions Standard
            </h3>
            <p className="mt-2 max-w-full text-sm leading-relaxed text-charcoal/65 sm:max-w-md" data-id="element-510" data-mp="2gku1a0sugi6p">
              Below is our criteria used to evaluate any equipment before it&apos;s
              implemented into your practice.
            </p>

            <div className="before-you-buy__factors mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-511" data-mp="2pjp8ng7mjybl">
              {REVIEW_FACTORS.map(({
              label,
              icon: Icon
            }) => <div key={label} className="before-you-buy__factor group min-w-0 rounded-xl border border-slate-100 bg-slate-50 px-3.5 py-3 transition-[transform,border-color,background-color,box-shadow] duration-200 hover:-translate-y-0.5 hover:border-teal/40 hover:bg-teal/[0.04] hover:shadow-sm" data-id="element-512" data-mp="1xuce0bqs6esq">
                  <div className="flex items-center gap-2.5" data-id="element-513" data-mp="1dtj24duaa7r0">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-teal/10 text-teal transition-colors duration-200 group-hover:bg-teal group-hover:text-white" data-id="element-514" data-mp="1irufuznp92ei">
                      <Icon className="h-3.5 w-3.5" data-id="element-515" data-mp="2bef61wsfv8gh" />
                    </span>
                    <span className="min-w-0 text-[12px] font-semibold leading-snug text-navy" data-id="element-516" data-mp="1wipg5nk4ub6h">
                      {label}
                    </span>
                  </div>
                  <div className="mt-3 h-px w-8 bg-teal/60 transition-[width] duration-200 group-hover:w-full" data-id="element-517" data-mp="21j3mn1635d2e" />
                </div>)}
            </div>
          </div>
        </aside>
      </div>
    </section>;
}